import { Router } from '@reach/router';
import React from 'react';
import { DocumentSection } from '../features/documents/documents-section/DocumentSection';
import { NetSuiteSynchronisationInformation } from '../features/netsuite-synchronisation/NetSuiteSynchronisationInformation';
import { ProjectSection } from '../features/projects/project-section/ProjectSection';
import { Projects } from '../features/projects/Projects';
import { RouteComponentProps } from '../helpers/RouteComponentProps';
import { routes } from '../helpers/routes';
import { Layout } from '../layout/Layout';
import { NotFound } from '../NotFound';

type Props = RouteComponentProps & { logOut: () => void };

export const LayoutRoutes = (props: Props) => {
  return (
    <Layout logOut={props.logOut}>
      <Router primary={false}>
        <Projects path={routes.home} />
        <ProjectSection path={`${routes.projectSection}/*`} />
        <NetSuiteSynchronisationInformation path={routes.netSuiteSynchronisationInformation} />
        <DocumentSection path={`${routes.documentSection}/*`} />
        <NotFound default={true} />
      </Router>
    </Layout>
  );
};
